import {
	FETCH_PHARMACY_LIST_REQUEST,
	FETCH_PHARMACY_LIST_SUCCESS,
	FETCH_PHARMACY_LIST_FAILURE
} from "../../../constants"

const initialState = {
	loading: false,
	data: null,
	error: null,
};

const pharmacyListReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_PHARMACY_LIST_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: null,
			};
		case FETCH_PHARMACY_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			}
		case FETCH_PHARMACY_LIST_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null
			}
		default:
			return state;
	}
}
export default pharmacyListReducer